var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 372,
    viewBox: "0 0 377 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.942 315.182C259.835 315.182 321.358 253.774 321.358 178.024C321.358 102.274 259.835 40.8662 183.942 40.8662C108.05 40.8662 46.5264 102.274 46.5264 178.024C46.5264 253.774 108.05 315.182 183.942 315.182Z",
    fill: "#47007F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.244 241.654H52.4727V371.346H322.244V241.654Z",
    fill: "#25223B",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.786 121.834C184.992 140.065 164.964 150.78 142.107 166.94C129.173 176.084 117.231 184.638 107.447 197.081C97.6626 209.524 93.9146 228.393 103.494 240.999C112.327 252.632 131.445 254.498 144.887 245.199C139.113 235.957 138.998 224.029 142.254 213.633C145.51 203.237 150.16 191.269 156.672 182.534C172.78 160.956 190.987 140.098 210.778 121.834C210.45 121.507 210.819 122.309 210.778 121.834H210.786Z",
    fill: "#0EA073",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.976 120.754C190.98 142.316 172.165 152.647 146.101 182.035C130.19 199.979 127.295 214.419 128.755 227.77C131.117 249.373 151.293 266.834 172.994 268.594C194.695 270.346 216.248 257.887 227.903 239.534C239.565 221.181 241.944 197.867 237.047 176.689C232.151 155.512 229.724 132.255 212.968 120.754H212.976Z",
    fill: "#FF6B18",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.867 125.125C187.814 138.862 170.189 157.796 157.993 179.751C153.072 188.608 148.931 198.612 150.514 208.615C152.818 223.17 167.843 233.787 182.598 233.329C197.352 232.87 210.786 222.867 217.733 209.868C224.68 196.868 225.77 181.356 223.359 166.817C220.948 152.279 215.256 138.51 208.859 125.117L208.867 125.125Z",
    fill: "#FFA450",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.163 121.352C199.788 132.927 187.97 140.925 178.809 162.151C174.56 171.999 174.7 183.975 179.711 193.455C184.73 202.934 196.885 209.058 206.726 204.743C212.673 202.14 216.749 196.328 218.635 190.131C220.521 183.934 220.48 177.328 220.12 170.853C219.168 154.006 214.28 137.88 211.163 121.344V121.352Z",
    fill: "#FFCE00",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M291.62 81.3381C272.79 107.149 257.075 123.824 240.385 146.704C230.946 159.646 222.26 171.712 216.872 186.922C211.483 202.132 213.903 221.754 227.05 231.143C239.18 239.804 258.027 235.736 267.91 222.474C259.454 215.213 255.558 203.564 255.37 192.382C255.181 181.2 255.804 168.045 259.257 157.485C267.77 131.388 278.531 105.34 291.62 81.3463C291.202 81.1253 291.809 81.7966 291.62 81.3463V81.3381Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.786 121.834C196.918 138.608 174.142 151.926 152.753 156.085C133.094 159.908 112.844 157.452 92.8488 156.347C72.8536 155.242 51.948 155.692 34.0605 164.68C17.9528 172.776 5.25685 188.133 2.12388 205.856C-1.00909 223.579 6.29844 243.177 21.2908 253.172C36.2831 263.167 58.3697 261.874 71.0001 249.03C77.4218 242.497 81.2355 232.69 78.406 223.988C77.3234 220.649 75.3222 217.603 74.6907 214.149C73.2801 206.462 78.8899 199.299 84.836 194.199C116.863 166.735 155.869 183.787 210.786 121.834V121.834Z",
    fill: "#7800C6",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.163 121.351C195.58 134.015 179.292 140.286 159.199 139.999C149.791 139.86 138.08 137.535 128.426 130.618C121.66 125.772 115.189 118.282 112.68 110.357C109.202 99.3554 110.605 89.4257 115.345 82.5903C123.235 71.2199 135.824 67.3069 145.953 67.2496C150.128 58.1713 144.994 47.2674 137.637 40.4894C122.439 26.4994 98.2204 24.502 79.7014 33.6704C61.1824 42.8388 52.2346 58.5724 48.2158 78.8166C45.3535 93.2322 48.0272 112.191 55.0231 125.133C63.9545 141.653 75.7401 154.513 93.6931 160.096C112.04 165.802 135.759 164.075 155.746 159.286C174.035 154.906 187.444 146.098 211.163 121.351V121.351Z",
    fill: "#7AB0E2",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4309 115.883C13.8762 118.74 7.07715 128.858 8.05313 138.772C9.0291 148.685 17.6899 157.28 27.6137 158.213C37.5375 159.147 47.6582 152.311 50.4713 142.766C53.2926 133.213 48.5029 122.006 39.6453 117.414C34.4783 114.737 27.8843 114.557 23.4227 115.891L23.4309 115.883Z",
    fill: "#FFCE00",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M329.7 108.254C323.959 109.965 319.874 116.047 320.465 121.998C321.055 127.949 326.255 133.115 332.218 133.671C338.18 134.236 344.257 130.127 345.947 124.397C347.636 118.658 344.766 111.929 339.443 109.171C336.335 107.558 332.382 107.451 329.7 108.254V108.254Z",
    fill: "#0EA073",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.418 72.3494C134.677 74.0603 130.592 80.1425 131.183 86.0938C131.773 92.0451 136.973 97.2105 142.935 97.7671C148.898 98.3238 154.975 94.2226 156.665 88.4923C158.354 82.7539 155.484 76.0249 150.161 73.2662C147.053 71.6536 143.099 71.5472 140.418 72.3494V72.3494Z",
    fill: "#7AB0E2",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M233.324 5.69047C236.875 1.09808 244.183 0.00933731 248.923 3.35744C253.664 6.70555 255.058 13.9502 251.909 18.8209C248.759 23.6916 241.558 25.378 236.555 22.431C231.552 19.484 228.633 11.7645 233.324 5.69866V5.69047Z",
    fill: "#F55800",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M248.891 250.863C258.126 256.332 269.985 254.539 280.007 250.691C309.598 239.329 313.256 227.23 323.024 194.208C324.59 188.911 327.215 180.594 330.266 175.977C339.378 162.184 354.395 160.857 361.038 164.811C380.828 176.583 377.982 196.86 370.937 213.117C363.884 229.375 348.99 241.048 333.087 248.907C309.483 260.572 282.459 265.222 248.891 250.872V250.863Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.062 180.93C213.074 197.523 210.728 211.521 218.101 227.943C222.932 238.716 232.536 247.049 243.567 251.298C254.598 255.546 266.949 255.865 278.473 253.197C289.577 250.626 300.239 245.166 307.621 236.497C314.994 227.828 318.709 215.745 315.945 204.711C313.181 193.676 303.331 184.36 291.964 183.615C281.614 182.927 271.87 188.969 264.825 196.565C257.78 204.162 252.712 213.347 246.413 221.566C241.795 227.591 239.089 232.772 231.175 232.019C227.189 231.643 224.777 229.899 222.046 226.969C219.676 224.423 215.903 218.193 215.214 209.991C214.32 199.3 215.92 190.303 220.062 180.922V180.93Z",
    fill: "#DB9C77",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.254 121.016C249.817 92.1927 287.946 63.3695 327.83 35.8725C327.855 35.8561 327.879 35.8807 327.863 35.9052C310.18 57.9913 292.933 80.0855 275.25 102.171C255.37 127.008 235.399 151.976 219.767 179.669C216.79 160.047 213.805 140.425 211.254 121.008V121.016Z",
    fill: "#FAB4B8",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M233.922 128.4L215.075 146.033L216.412 155.676L234.742 136.013L233.922 128.4Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M238.426 139.238L217.471 163.657L218.808 173.301L237.409 147.76L238.426 139.238Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.582 129.382C222.973 150.478 222.703 159.221 220.218 179.285C229.732 162.773 233.931 155.545 245.7 140.556C240.533 138.395 233.644 134.228 225.582 129.382V129.382Z",
    fill: "#FAB4B8",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M240.771 115.302L225.573 129.071C225.36 129.268 225.221 129.538 225.196 129.833L224.212 141.989L239.114 126.763L240.771 115.302V115.302Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M238.638 136.684C238.089 144.125 237.072 148.104 236.728 152.704",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M226.049 128.94C257.74 98.7906 295.221 64.6711 327.895 36.2654C327.912 36.249 327.936 36.2654 327.928 36.2899C312.526 76.3935 296.656 120.001 281.262 160.104C264.481 150.543 244.24 139.999 226.148 129.709C225.869 129.554 225.82 129.169 226.057 128.948L226.049 128.94Z",
    fill: "#FCE3E3",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.253 121.425C196.778 114.762 183.204 109.351 168.729 102.679C223.006 78.5302 272.863 58.859 327.788 36.2655C327.813 36.2573 327.829 36.29 327.813 36.3064C285.764 67.2907 250.776 92.3073 211.253 121.425Z",
    fill: "#FCE3E3",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.294 91.3086C198.541 92.4055 200.78 93.5025 203.027 94.5912C212.024 98.9789 220.997 103.334 229.895 107.55C230.461 112.609 231.331 117.635 232.495 122.596",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M242.271 113.624C257.871 122.801 273.175 130.356 288.954 138.575",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M195.81 90.834L168.729 102.679L176.331 106.076L201.83 93.9774L195.81 90.834Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M238.638 136.684L223.006 153.081L221.833 165.049L237.547 146.164L238.638 136.684Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M206.931 96.646L182.704 108.704L190.307 112.101L212.533 99.3638L206.931 96.646Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M217.979 102.032L196.934 115.032L204.717 118.47L224.532 105.217L217.979 102.032Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.094 117.562L233.02 133.844L243.288 139.238L257.444 122.146L249.094 117.562Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M230.658 113.624L212.246 128.4L213.583 138.035L232.241 121.352L230.658 113.624Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M264.85 126.1L251.481 143.683L259.822 148.12L271.993 130.144L264.85 126.1Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M279.531 133.819L268.804 152.705L278.235 158.509L287.347 137.732L279.531 133.819Z",
    fill: "#872345",
    stroke: "black",
    strokeWidth: 0.890135,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIllustration);
export default __webpack_public_path__ + "static/media/Success-illustration.bdf0131a6a7f52060651a0e57d28a267.svg";
export { ForwardRef as ReactComponent };